import { useTranslate } from 'react-translate.ts';
import { TRANSLATIONS_ROOT_KEY } from '../../constants/translation.constants';

export default function ForbiddenPage() {
    const translate = useTranslate(TRANSLATIONS_ROOT_KEY);

    return (
        <div>
            <h1>403</h1>
            <h2>{translate('error.forbidden')}</h2>
        </div>
    );
}
